export default "__VITE_ASSET__D$YYqBVI__"